/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import React from 'react';

import { IntlProvider } from './src/components/Providers/Intl';
import { CategoryProvider } from './src/components/Providers/BlogCategory';
import { Provider } from './src/components/Providers/Blade';

// * Wrapping our app in our Blade provider
// eslint-disable-next-line react/prop-types
export const wrapRootElement = ({ element }) => {
  let activateInterval = null;
  if (typeof window !== 'undefined') {
    activateInterval = setInterval(() => {
      if (window.activateOptimizelyWebExperiment) {
        window.activateOptimizelyWebExperiment();
        clearInterval(activateInterval);
      }
    }, 10);
    setTimeout(() => {
      clearInterval(activateInterval);
    }, 10000);
  }
  return (
    <Provider>
      <IntlProvider>
        <CategoryProvider>{element}</CategoryProvider>
      </IntlProvider>
    </Provider>
  );
};
